<template>
    <div class="success-page">
        <div class="container">
            <div class="success-content" ref="content">
                <div class="logo">
                    <img :src="finalWebsite.logoFinal"/>
                </div>

                <div class="success-icon">
                    <fa icon="fa-circle-check" class="check-icon"/>
                </div>
                
                <div class="success-message">
                    <h1>Parabéns! Seu período de teste foi ativado!</h1>
                    <div class="next-steps">
                        <p class="info-email">
                            Você agora tem acesso ao período de teste gratuito.<br>
                            Aproveite para explorar todos os conteúdos disponíveis na plataforma!
                        </p>
                    </div>
                </div>

                <div class="trial-details">
                    <h3>Detalhes do Trial</h3>
                    <div class="trial-info">
                        <p><strong>Nome do Usuário:</strong> {{ userName }}</p>
                        <p><strong>Email:</strong> {{ userEmail }}</p>
                        <p v-if="trialDays"><strong>Duração do Trial:</strong> {{ trialDays }} dias</p>
                        <p v-if="trialStart"><strong>Início:</strong> {{ formatarData(trialStart) }}</p>
                        <p v-if="trialEnd"><strong>Fim:</strong> {{ formatarData(trialEnd) }}</p>
                    </div>
                </div>

                <div class="action-buttons">
                    <button @click="redirect" class="btn-primary">
                        <fa style="color: white;" icon="fa-right-to-bracket" /> Ir para o site
                    </button>
                </div>
            </div>
        </div>

        <footer class="footer">
            <div class="footer-content">
                <div class="logo-footer">
                    <img src="@/assets/Weflix/logo_weflix-black.png" alt="Weflix Logo"/>
                </div>
                <p class="copyright">© 2024 Weflix - Todos os direitos reservados</p>
            </div>
        </footer>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'SuccessTrialPage',
    computed: {
        ...mapState(['userPortalWeflix', 'finalWebsite']),
        userName() {
            return this.userPortalWeflix?.user?.name || '';
        },
        userEmail() {
            return this.userPortalWeflix?.user?.email || '';
        },
        trialDays() {
            // Se disponível, ajuste conforme a lógica do backend
            return this.userPortalWeflix?.trialDays || 7;
        },
        trialStart() {
            // Ajuste conforme a estrutura real do objeto
            return this.userPortalWeflix?.trialStart || new Date();
        },
        trialEnd() {
            // Ajuste conforme a estrutura real do objeto
            return this.userPortalWeflix?.trialEnd || null;
        }
    },
    methods: {
        formatarData(data) {
            if (!data) return '';
            const dataObj = new Date(data);
            const ano = dataObj.getFullYear();
            const mes = ('0' + (dataObj.getMonth() + 1)).slice(-2);
            const dia = ('0' + dataObj.getDate()).slice(-2);
            return `${dia}/${mes}/${ano}`;
        },
        redirect() {
            this.$router.push('/');
        }
    },
    mounted() {
        // Atualiza favicon se necessário
        if (this.finalWebsite?.faviconFinal) {
            const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'icon';
            link.href = this.finalWebsite.faviconFinal;
            document.getElementsByTagName('head')[0].appendChild(link);
        }
    }
}
</script>

<style scoped>
.success-page {
    min-height: 100vh;
    background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
    display: flex;
    flex-direction: column;
    position: relative;
}

.success-content {
    max-width: 800px;
    margin: 60px auto;
    text-align: center;
    padding: 40px 20px;
    background: white;
    border-radius: 20px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.05);
}

.logo img {
    max-width: 200px;
    height: auto;
    margin-bottom: 20px;
}

.success-icon {
    margin-bottom: 30px;
}

.success-icon .check-icon {
    font-size: 80px;
    color: #4CAF50;
}

.success-message h1 {
    color: #2C3E50;
    font-size: 32px;
    margin-bottom: 15px;
}

.info-email {
    color: #7f8c8d;
    font-size: 18px;
    margin-bottom: 30px;
}

.trial-details {
    background: #f8f9fa;
    padding: 20px;
    border-radius: 12px;
    margin: 30px 0;
    text-align: left;
    page-break-inside: avoid;
}

.trial-details h3 {
    color: #2C3E50;
    margin-bottom: 20px;
    text-align: center;
}

.trial-info {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
}

.trial-info p {
    margin: 5px 0;
    color: #666;
    page-break-inside: avoid;
}

.action-buttons {
    display: flex;
    gap: 15px;
    justify-content: center;
    page-break-inside: avoid;
}

.btn-primary {
    background: #2196F3;
    color: white;
    border: none;
    padding: 15px 40px;
    border-radius: 30px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 10px;
}

.btn-primary:hover {
    background: #1976D2;
    transform: translateY(-2px);
}

.footer {
    padding: 20px;
    margin-top: auto;
    box-shadow: 0 -5px 20px rgba(0,0,0,0.05);
    background: white;
    page-break-inside: avoid;
}

.footer-content {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
}

.logo-footer img {
    width: 120px;
    margin-bottom: 15px;
}

.copyright {
    color: #95a5a6;
    font-size: 14px;
}

@media (max-width: 768px) {
    .success-content {
        margin: 20px;
    }
    .trial-info {
        grid-template-columns: 1fr;
    }
    .action-buttons {
        flex-direction: column;
    }
}
</style>
